"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/state/normal.js
// module id = 453
// module chunks = 61